import NotificationsDom from '../dom/notifications-dom';
import HtmlHelper from '../utils/html-helper';
import StaticStateModule from './static-state-module';
import HttpHelper from '../utils/http-helper';
import Workarea from './workarea';
import { DatatypeHelper } from '../utils/datatype-helper';

export default class AuthorityRegistrationModule {

    constructor() {
        this.staticStateModule = null;
        this.workareaModule = new Workarea();

        this.registrationFormSection = document.querySelector('#registration-form');
        this.registrationSuccessSection = document.querySelector('#registration-success');

        this.authorityNameInput = document.querySelector('#authorityNameInput');
        this.authorityNameShortInput = document.querySelector('#authorityNameShortInput');
        this.authorityNameLocationInput = document.querySelector('#authorityNameLocationInput');

        this.organizationalUnitNameInput = document.querySelector('#organizationalUnitNameInput');
        this.organizationalUnitLocationInput = document.querySelector('#organizationalUnitLocationInput');
        this.organizationalUnitStateSelect = document.querySelector('#organizationalUnitStateSelect');
        this.organizationalUnitStateSelectlabelSelected = '';

        this.typeOfAuthority = document.querySelector('#typeOfAuthority');

        // this.salutation = document.querySelector('#salutation');
        this.firstName = document.querySelector('#firstName');
        this.lastName = document.querySelector('#lastName');
        this.email = document.querySelector('#email');
        this.phone = document.querySelector('#phone');
        this.personBusinessAddressInput = document.querySelector('#personBusinessAddressInput');
        this.personBusinessAddressCKE = this.personBusinessAddressInput.nextSibling;

        this.position = document.querySelector('#position');

        this.checkboxOtherAcademicRecognitions = document.querySelector('#checkboxOtherAcademicRecognitions');
        this.otherAcademicRecognitionsDescriptionInput = document.querySelector('#otherAcademicRecognitionsDescriptionInput');
        this.checkboxOtherProfessionalResponsibilities = document.querySelector('#checkboxOtherProfessionalResponsibilities');
        this.otherProfessionalResponsibilitiesDescriptionInput = document.querySelector('#otherProfessionalResponsibilitiesDescriptionInput');

        this.past = document.querySelector('#past');

        this.comment = document.querySelector('#comment');

        this.password = document.querySelector('#password');
        this.saltwater = document.querySelector('#saltwater');
        this.userNewPasswordValidation = document.querySelector('#userNewPasswordValidation');
        this.passwordHint = document.querySelector('#passwordHint');
        this.emailHint = document.querySelector('#emailHint');
        this.passwordMismatch = document.querySelector('#passwordMismatch');

        this.registerButton = document.querySelector('#registerButton');

        this.checkboxesParagraph = document.querySelector('#checkboxesParagraph');

        this.invalidForms = null;

        this.passwordMatchesRequierement = false;
        this.passwordMatches = false;
        this.emailExists = false;
        this.strongRegex = new RegExp('^(?=.*[a-zßà-ÿšž])(?=.*[A-ZŽÀ-ÝŸ])(?=.*[0-9])(?=.*[<>|@€,;.:^°_!§$%&/()=?{}\\[\\]*\\\\+~#\\-])[A-ZŽÀ-ÝŸa-zßà-ÿšž0-9<>|@€,;.:^°_!§$%&/()=?{}\\[\\]*\\\\+~#\\-]{10,}$');
        this.mediumRegex = new RegExp('^(?=.*[a-zßà-ÿšž])(?=.*[A-ZŽÀ-ÝŸ])(?=.*[0-9])(?=.*[<>|@€,;.:^°_!§$%&/()=?{}\\[\\]*\\\\+~#\\-])[A-ZŽÀ-ÝŸa-zßà-ÿšž0-9<>|@€,;.:^°_!§$%&/()=?{}\\[\\]*\\\\+~#\\-]{8,}$');


        this.inputElements = [];
        this.selectElements = [];
        this.checkboxElements = [];
        this.initialize().then(() => {
            this.initializeHtmlElements();
            this.addEventListeners();
            // if(!!this.staticStateModule?.regionSelect?.options[1]) {
            //     this.staticStateModule?.regionSelect?.options[1].label = 'Bundesweit';
            // }
            this.organizationalUnitStateSelect.innerHTML = this.staticStateModule.regionSelect.innerHTML;
                //remove "Alle Bundesländer" option
            this.organizationalUnitStateSelect?.querySelector('[label=Bundesweit]')?.remove()

            this.checkboxOtherAcademicRecognitions.dispatchEvent(new Event('change'));
            this.checkboxOtherProfessionalResponsibilities.dispatchEvent(new Event('change'));
        });
    }

    initializeHtmlElements() {
        this.inputElements.push(this.authorityNameInput, this.authorityNameShortInput, this.authorityNameLocationInput,
            this.organizationalUnitNameInput, this.organizationalUnitLocationInput, this.firstName,
            this.lastName, this.phone,
            this.personBusinessAddressInput, this.position, this.otherAcademicRecognitionsDescriptionInput,
            this.otherProfessionalResponsibilitiesDescriptionInput, this.comment,
        );
        this.selectElements.push(this.organizationalUnitStateSelect, this.typeOfAuthority);
        this.checkboxElements.push(this.checkboxOtherAcademicRecognitions,
            this.checkboxOtherProfessionalResponsibilities, this.past);
        this.workareaModule.checkboxElements.forEach(checkbox => {
            this.checkboxElements.push(checkbox);
        });
        document.querySelectorAll('textarea')?.forEach(textarea => textarea?.value = null);
    }


    addEventListeners() {
        this.organizationalUnitStateSelect.addEventListener('change', () => {
            this.organizationalUnitStateSelectlabelSelected = this.organizationalUnitStateSelect.options[this.organizationalUnitStateSelect.selectedIndex].text;
        });
        this.inputElements.forEach(element => {
            element.addEventListener('input', () => {
                HtmlHelper.validateInputForm(element);
                if(element.id === 'personBusinessAddressInput') {
                    this.validateCKE();
                }
            });
        });
        this.selectElements.forEach(element => {
            element.addEventListener('change', () => {
                HtmlHelper.validateSelectForm(element);
            });
        });
        this.checkboxElements.forEach(element => {
            element.addEventListener('change', () => {
                HtmlHelper.validateCheckbox(element, this.checkboxesParagraph);
            });
        });
        this.workareaModule.checkboxElements.forEach(element => {
            element.addEventListener('change', () => {
                HtmlHelper.validateCheckbox(element, this.checkboxesParagraph);
            });
        });
        this.checkboxOtherAcademicRecognitions.addEventListener('change', () => {
            if (this.checkboxOtherAcademicRecognitions.checked) {
                this.otherAcademicRecognitionsDescriptionInput.setAttribute('required', 'text');
                this.otherAcademicRecognitionsDescriptionInput.parentElement.classList.remove('d-none');
            } else {
                this.otherAcademicRecognitionsDescriptionInput.removeAttribute('required');
                this.otherAcademicRecognitionsDescriptionInput.parentElement.classList.add('d-none');
                this.otherProfessionalResponsibilitiesDescriptionInput.classList.remove('invalid-form');
            }
        });
        this.checkboxOtherProfessionalResponsibilities.addEventListener('change', () => {
            if (this.checkboxOtherProfessionalResponsibilities.checked) {
                this.otherProfessionalResponsibilitiesDescriptionInput.setAttribute('required', 'text');
                this.otherProfessionalResponsibilitiesDescriptionInput.parentElement.classList.remove('d-none');
            } else {
                this.otherProfessionalResponsibilitiesDescriptionInput.removeAttribute('required');
                this.otherProfessionalResponsibilitiesDescriptionInput.parentElement.classList.add('d-none');
                this.otherProfessionalResponsibilitiesDescriptionInput.classList.remove('invalid-form');
            }
        });
        this.password.addEventListener('input', () => {
            HtmlHelper.validateInputForm(this.password);
            this.passwordHint.classList.remove('strong-color', 'medium-color', 'weak-color');
            this.passwordHint.innerHTML = '';
            if (/[^a-zA-ZÀ-ž0-9#?!@§()+$%&*\-.,_~]/.test(this.password.value)) {
                this.passwordHint.classList.add('weak-color');
                this.passwordHint.appendChild(HtmlHelper.createElementFromHTML('Passwort enthält nicht erlaubte Zeichen'));
                this.passwordMatchesRequierement = false;
            } else {
                if (this.strongRegex.test(this.password.value)) {
                    this.passwordHint.classList.add('strong-color');
                    this.passwordHint.appendChild(HtmlHelper.createElementFromHTML('Passwort ist stark'));
                    this.passwordMatchesRequierement = true;
                } else if (this.mediumRegex.test(this.password.value)) {
                    this.passwordHint.classList.add('medium-color');
                    this.passwordHint.appendChild(HtmlHelper.createElementFromHTML('Passwort ist ausreichend'));
                    this.passwordMatchesRequierement = true;
                } else {
                    this.passwordHint.classList.add('weak-color');
                    this.passwordHint.appendChild(HtmlHelper.createElementFromHTML('Passwort ist zu schwach'));
                    this.passwordMatchesRequierement = false;
                }
            }
            this.userNewPasswordValidation.dispatchEvent(new Event('input'));
        });
        this.userNewPasswordValidation.addEventListener('input', () => {
            HtmlHelper.validateInputForm(this.userNewPasswordValidation);
            this.passwordMismatch.classList.remove('strong-color', 'medium-color', 'weak-color');
            this.passwordMismatch.innerHTML = '';
            if (this.userNewPasswordValidation.value === this.password.value && this.userNewPasswordValidation.value !== '') {
                this.passwordMismatch.classList.add('strong-color');
                this.passwordMismatch.appendChild(HtmlHelper.createElementFromHTML('Passwort stimmt überein'));
                this.passwordMatches = true;
            } else {
                this.passwordMismatch.classList.add('weak-color');
                this.passwordMismatch.appendChild(HtmlHelper.createElementFromHTML('Passwort stimmt nicht überein'));
                this.passwordMatches = false;
            }
        });
        this.registerButton.addEventListener('click', () => {
            this.register().then();
        });
        this.staticStateModule.regionSelect.addEventListener('change', () => {
            HtmlHelper.validateSelectForm(this.staticStateModule.regionSelect);
        });

        this.saltwater.addEventListener('input', () => {
            if (this.saltwater.value !== '') {
                this.registerButton.remove();
            }
        });

        this.email.addEventListener('input', () => {
            if (!this.emailExists) {
                HtmlHelper.validateInputForm(this.email)
            } else {
                this.emailExists = false;
                this.emailHint.innerHTML = '';
            }
        })
    }

    async initialize() {
        this.staticStateModule = new StaticStateModule();
        this.staticStateModule.addEventListener();
        await this.workareaModule.loadWorkareas();
        await this.staticStateModule.loadLocations();
    }

    validateForm() {
        this.invalidForms = null;
        this.inputElements.forEach(element => {
            HtmlHelper.validateInputForm(element);
        });
        this.selectElements.forEach(element => {
            HtmlHelper.validateSelectForm(element);
        });
        HtmlHelper.validateSelectForm(this.staticStateModule.regionSelect);
        HtmlHelper.validateInputForm(this.password);
        HtmlHelper.validateInputForm(this.userNewPasswordValidation);
        HtmlHelper.validateCheckboxGroup(this.checkboxElements, this.checkboxesParagraph);
        if (!this.checkboxOtherAcademicRecognitions.checked && !this.checkboxOtherProfessionalResponsibilities.checked) {
            HtmlHelper.validateCheckboxGroup(this.workareaModule.checkboxElements, this.checkboxesParagraph);
        }
        HtmlHelper.validateEmailForm(this.email);
        this.validateCKE();
        this.invalidForms = document.querySelectorAll('.invalid-form');
    }

    validateCKE() {
        if(this.personBusinessAddressInput.classList.contains('invalid-form')) {
            this.personBusinessAddressCKE.classList.add('invalid-form')
        } else {
            this.personBusinessAddressCKE.classList.remove('invalid-form')
        }
    }

    async register() {
        this.validateForm();
        if (!!this.passwordMatches && !!this.passwordMatchesRequierement && this.invalidForms.length === 0) {
            this.postData = {};
            this.selectElements.forEach(element => {
                Object.assign(this.postData, { [element.id]: element.value });
            });
            this.inputElements.forEach(element => {
                Object.assign(this.postData, { [element.id]: element.value });
            });
            this.checkboxElements.forEach(element => {
                Object.assign(this.postData, { [element.id]: element.checked });
            });
            this.workareas = { workareas: [] };
            this.workareaModule.checkboxElements.forEach(element => {
                if (element.checked) {
                    this.workareas.workareas.push({ _id: element.id, nameShort: element.name });
                }
            });
            Object.assign(this.postData, this.workareas);
            Object.assign(this.postData, { agencyState: this.staticStateModule.regionSelect.value });
            Object.assign(this.postData, { [this.password.id]: this.password.value });
            Object.assign(this.postData, { [this.email.id]: this.email.value });

            await HttpHelper.postData(`${location.origin}/api/public/auth/register`, this.postData)
                .then((response) => {
                    response = response?.data;
                    if (response === true) {
                        this.registrationFormSection.classList.add('d-none');
                        this.registrationSuccessSection.classList.remove('d-none');
                        this.renderRegistrationSuccessTemplate();
                        return;
                    }

                    if (response.hasOwnProperty('passwordInvalid')) {
                        NotificationsDom.renderErrorNotification('Password ist nicht valid order entspricht nicht den Voraussetzungen')
                        return;
                    }
                    if (response.hasOwnProperty('userExists')) {
                        NotificationsDom.renderErrorNotification('Ein Benutzer mit dieser Email ist bereits registriert')
                        this.email.classList.add('invalid-form');
                        this.emailExists = true
                        this.email.scrollIntoView()
                        this.emailHint.innerHTML = 'Ein Benutzer mit dieser Email ist bereits registriert'
                        return;
                    }


                    NotificationsDom.renderErrorNotification('Daten konnten nicht verarbeitet werden!')
                });
        } else {
            NotificationsDom.renderCautionNotification('Bitte füllen Sie alle Pflichtfelder aus!');
        }
    }

    renderRegistrationSuccessTemplate() {
        let selectedWorkAreas = '';
        this.workareaModule?.checkboxElements.forEach((workArea, index) => {
            if (!!workArea.checked) {
                selectedWorkAreas += workArea.name;

                if (index < this.workareaModule.checkboxElements.length) {
                    selectedWorkAreas += '<br>';
                }
            }
        });
        if (!!this.checkboxOtherAcademicRecognitions.checked) {
            selectedWorkAreas += this.otherAcademicRecognitionsDescriptionInput.value + '<br>';
        }
        if (!!this.checkboxOtherProfessionalResponsibilities.checked) {
            selectedWorkAreas += this.otherProfessionalResponsibilitiesDescriptionInput.value + '<br>';
        }
        if(this.staticStateModule?.regionsSelected === 'Alle Bundesländer' || this.staticStateModule?.regionsSelected === 'Bundesweit') {
            this.staticStateModule?.regionsSelected = 'Bundesweit';
        }
        const htmlTemplate = `
            <div class="col-11">
                <h2>Neue Registrierung</h2>
                <br>
                <p>Guten Tag ${this.firstName.value} ${this.lastName.value}</p>
                
                <p>vielen Dank für Ihre Anmeldung in der anabin-Datenbank vom ${DatatypeHelper.getDateToday()}. 
                <br>Wir haben Ihnen eine E-Mail an
                    die von Ihnen angegebene E-Mail-Adresse geschickt. 
                <br>Bitte öffnen Sie diese und klicken Sie auf den darin
                    enthaltenen Link. 
                <br>Prüfen Sie ggf. bitte auch Ihren Spam- bzw. Junk-E-Mail-Ordner. </p>
                
                <p>Mit Klick auf den Link bestätigen Sie die angegebene E-Mail-Adresse. Erst dann können wir Ihren Antrag prüfen.</p>
                
                <p>Die Bearbeitung dauert in der Regel zwei Werktage.</p>
                
                <p>Alle Daten wurden erfolgreich gespeichert!
                    Sie können diese Seite für Ihre Unterlagen ausdrucken.</p>
                
                <p>Ihre Anmeldedaten:</p>
                <div id="registration-summary">
                    <div class="col-12">
                        <h2 class="padding-left">Angaben zur Behörde / Hochschule / Stelle</h2>
                        <div class="row">
        
                            <div class="col-3 padding-left">
                                Name der Behörde
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.authorityNameInput.value}
                            </div>
        
                            <div class="col-3 padding-left">
                                Abkürzung / Kurzbezeichnung
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.authorityNameShortInput.value}
                            </div>
        
                            <div class="col-3 padding-left">
                                Sitz
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.authorityNameLocationInput.value}
                            </div>
        
                            <div class="col-3 padding-left">
                                Bundesland
                            </div>
                            <div class="col-7 padding-left">
                                ${this.staticStateModule?.labelSelected === 'Alle Bundesländer' || this.staticStateModule?.labelSelected === 'Bundesweit' ? 'Bundesweit' : this.staticStateModule?.labelSelected}
                            </div>
                        </div>
                        
                        <hr style="margin-top: 1em">
                        
                        <h2 class="padding-left">Ihre Organisationseinheit</h2>
                        <div class="row">
                        
                            <div class="col-3 padding-left">
                                Name
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.organizationalUnitNameInput.value}
                            </div>
        
                            <div class="col-3 padding-left">
                                Ort (wenn abweichend)
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.organizationalUnitLocationInput.value}
                            </div>
        
                            <div class="col-3 padding-left">
                                Bundesland (wenn abweichend)
                            </div>
                            <div class="col-7 padding-left">
                                ${this.organizationalUnitStateSelectlabelSelected ?? ''}
                            </div>
                        </div>
                        
                        <hr style="margin: 1em 0 1em 0">

                        <div class="row">
                        
                            <div class="col-3 padding-left padding-left">
                                Art der Behörde
                            </div>
                            <div class="col-7 padding-left">
                                ${this.typeOfAuthority.value}
                            </div>
                        </div>
                        
                        <hr style="margin-top: 1em">

                        <h2 class="padding-left">Angaben zu Ihrer Person</h2>
                        <div class="row">
        
                            <div class="col-3 padding-left">
                                Vorname
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.firstName.value}
                            </div>
        
                            <div class="col-3 padding-left">
                                Nachname
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.lastName.value}
                            </div>       
                             
                            <div class="col-3 padding-left">
                                Dienstliche E-Mail
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.email.value}
                            </div>      
                             
                            <div class="col-3 padding-left">
                                Dienstliche Telefonnummer
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.phone.value}
                            </div>      
                             
                            <div class="col-3 padding-left">
                                Dienstliche Anschrift
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.personBusinessAddressInput.value}
                            </div>      
                             
                            <div class="col-3 padding-left">
                                Position
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${this.position.value}
                            </div>      
                             
                            <div class="col-3 padding-left">
                                Aufgabengebiet(e)
                            </div>
                            <div class="col-7 padding-bottom padding-left">
                                ${selectedWorkAreas}
                            </div>
                            
                            <div class="col-3 padding-left">
                                Kommentar
                            </div>
                            <div class="col-7 padding-left">
                                ${this.comment.value}
                            </div>      
                        </div>
                    </div>
                </div>
            </div>
        `;
        this.registrationSuccessSection.appendChild(HtmlHelper.createElementFromHTML(htmlTemplate));
        window.scrollTo(0, 0);
    }
}
